import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import { Button, IconButton, TextField, Tooltip } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { useEffect, useState } from "react";
import { VerifiyOldKioskPinCode } from "../../../../entities/ServicesEntities/VerificationsEntities/VerificationKioskPinEntity";
import {
  INPUTS_PROPS
} from "../../../../enums/Enums";
import Icons from "../../../../resources/icons/Icons";
import Strings from "../../../../resources/Strings";
import * as actionsService from "../../../../services/ActionsService/ActionsService";
import classes from "../CustomInputs.module.css";
import PasswordInput from "./PasswordInput";
import TextInput from "./TextInput";
import CustomTooltip from "../../Tooltip/CustomTooltip/CustomTooltip"
const VerificationPINInput = (props) => {
  const [showVerificationMessage, setShowVerificationMessage] = useState(false);
  const [isVerifiy, setIsVerifiy] = useState(true);
  const [isVerificationClicked, setIsVerificationClicked] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [kioskPinData, setKioskPinData] = useState({
    kioskPIN: "", // ""
    newPersonalPin: "",
    verifyNewPersonalPin: "",
  });

  const [verifiyErrorMessage, setVerifiyErrorMessage] = useState("");

  const resetPinInfo = () => {
    setKioskPinData({
      kioskPIN: "", // ""
      newPersonalPin: "",
      verifyNewPersonalPin: ""
    });
  };

  const handleClose = () => {
    setIsVerifiy(true);
    resetPinInfo();
    setShowVerificationMessage(false);
  };

  const handleOpen = () => {
    setShowVerificationMessage(true);
  };

  useEffect(() => {
    if (props.handleError) {
      setIsVerificationClicked(false);
      props.onChange({ [props.isCodeVerified]: isVerifiy });
      props.handleError({
        [props.id]: props.hasError,
        [props.codeVerifiedId]: !isVerifiy,
      });
    }
  }, [props.value, isVerifiy]);

  const confirmKioskData = (event) => {
    if (kioskPinData.newPersonalPin !== kioskPinData.verifyNewPersonalPin) {
      setIsVerifiy(false);
      setVerifiyErrorMessage(Strings.INPUT_ERROR_MESSAGES.UNMATCHED_PASSWORDS);
    } else if (
      !kioskPinData.newPersonalPin ||
      !kioskPinData.verifyNewPersonalPin
    ) {
      setIsVerifiy(false);
      setVerifiyErrorMessage(Strings.INPUT_ERROR_MESSAGES.EMPTY_KIOSK_PIN);
    } else {
      const oldPin = kioskPinData.kioskPIN;
      const verificationCodeEntity = new VerifiyOldKioskPinCode(
        props.additionalDataId,
        oldPin
      );

      setIsVerifiy(true);
      setVerifiyErrorMessage("");
      setShowVerificationMessage(false);
      props.updateKioskPIN(kioskPinData.newPersonalPin);
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target ? event.target : event;
    setKioskPinData({ ...kioskPinData, [name]: value });
    props.onChange({ [name]: value });

    setKioskPinData({ ...kioskPinData, ...event });
    if (props.isEditMode) setIsVerifiy(false);
  };

  const getHelperText = () => {
    if ((props.isStepSubmitted || isVerificationClicked) && props.hasError) {
      return props.errorMessage;
    }
  };

  const hasError = () => {
    return (
      ((props.isStepSubmitted || isVerificationClicked) && props.hasError) ||
      (props.isStepSubmitted && !isVerifiy)
    );
  };

  return (
    <div className={classes.customTextField}>
      <TextField
        fullWidth
        label={props.label}
        id={props.id}
        name={props.id}
        type={!props.isEditMode && showPassword ? "text" : "password"}
        className={classes.textField}
        autoComplete={'new-password'}
        value={(props?.value || "").slice(0, 12)}
        disabled={props.isEditMode}
        onChange={!props.isEditMode ? handleChange : null}
        error={hasError()}
        helperText={getHelperText()}
        InputLabelProps={{ shrink: true }}
        InputProps={{
          classes: {
            notchedOutline: classes.filed,
          },
          endAdornment: (
            <span className={classes.endAdornment}>
              {!showVerificationMessage && (
                <Button className={classes.inputButton} onClick={handleOpen}>
                  {props.isEditMode ? Strings.CHANGE : ""}
                </Button>
              )}
              
              {/* show Visibility Icon only on add new parker case */}
              {!props.isEditMode && !props.fromGmt &&
                <IconButton
                  aria-label="Toggle password visibility"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {!props.isEditMode && showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>}
              {<CustomTooltip {...props} style={{ marginTop: "0px" }}></CustomTooltip>}
            </span>
          ),
        }}
        FormHelperTextProps={{
          classes: {
            error: classes.error,
          },
        }}
      />
      {showVerificationMessage && (
        <div className={classes.codeVerification}>
          <span className={classes.verificationMessage}>
            {Strings.CHANGE_PASSWORD_MESSAGE}
          </span>
          <div className={classes.action}>
            <PasswordInput
              label={Strings.INPUT_LABELS.NEW_PIN}
              id={INPUTS_PROPS.NEW_PIN}
              value={kioskPinData.newPersonalPin}
              onChange={handleChange}
              isStepSubmitted={props.isStepSubmitted}
              handleError={false}
              hasError={false}
              errorMessage=""
              showTooltip={false}
            />
            <PasswordInput
              label={Strings.INPUT_LABELS.VERIFY_NEW_PIN}
              id={INPUTS_PROPS.VERIFY_NEW_PIN}
              value={kioskPinData.verifyNewPersonalPin}
              onChange={handleChange}
              isStepSubmitted={props.isStepSubmitted}
              handleError={false}
              hasError={false}
              errorMessage=""
              showTooltip={false}
            />
            <Button className={classes.formButton} onClick={confirmKioskData}>
              {Strings.CONFIRM}
            </Button>
            <Button className={classes.cancelButton} onClick={handleClose}>
              {Strings.CANCEL}
            </Button>
          </div>
          {!isVerifiy && (
            <div className={classes.error}>{verifiyErrorMessage}</div>
          )}
        </div>
      )}
    </div>
  );
};

export default VerificationPINInput;
